import React from 'react';
import { Switch } from '../../../elements/Switch/Switch';
import { Row } from '../../../grid/Row/Row';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { CheckBoxParam } from '../../../types/CheckBoxParam';

export type PublishFormSwitchParameter =
  | CheckBoxParam<'pagePublishNonAreaSubPages'>
  | CheckBoxParam<'pagePublishAreaSubPages'>
  | CheckBoxParam<'importantChange'>
  | CheckBoxParam<'triggerTimeControlledPublication'>;

type PublishFormSwitch = {
  parameter: PublishFormSwitchParameter;
  onClick?: () => void;
};

export function PublishFormSwitch({ parameter, onClick }: PublishFormSwitch) {
  const { t } = useSonTranslation('PageManagement');

  return (
    <Row>
      <Switch
        label={t(`views.publish.form.inputs.${parameter.name}.label`)}
        helpText={t(`views.publish.form.inputs.${parameter.name}.labelHelpText`)}
        param={parameter}
        onClick={onClick}
      />
    </Row>
  );
}
